const PaintPaletteIcon = ({ className }) => (
    <div className={className}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
            id="Paint-Palette--Streamline-Flex"
        >
            <desc>
                {'Paint Palette Streamline Icon: https://streamlinehq.com'}
            </desc>
            <g id="paint-palette--color-colors-design-paint-painting-palette">
                <path
                    id="Vector"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.66062 10.3401c-0.33279 0 -0.52 -0.18 -0.52 -0.50001 0 -0.32 0.18721 -0.5 0.52 -0.5"
                    strokeWidth={1}
                />
                <path
                    id="Vector_2"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.66016 10.3401c0.3328 0 0.52 -0.18 0.52 -0.50001 0 -0.32 -0.1872 -0.5 -0.52 -0.5"
                    strokeWidth={1}
                />
                <path
                    id="Vector_3"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M0.5 7c0 4.16 2.34 6.5 6.5 6.5 1.02992 0 2.38894 -0.2665 2.7472 -1.2935 0.5194 -1.4887 -2.19937 -1.1066 -2.19937 -2.98088 0 -3.32094 5.95217 0.44657 5.95217 -3.99962C13.5 3.26968 11.16 0.5 7 0.5S0.5 2.84 0.5 7Z"
                    strokeWidth={1}
                />
                <path
                    id="Vector_4"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.55953 4.91997c0.6656 0 1.04 -0.3744 1.04 -1.04s-0.3744 -1.04 -1.04 -1.04 -1.04 0.3744 -1.04 1.04 0.3744 1.04 1.04 1.04Z"
                    strokeWidth={1}
                />
                <path
                    id="Vector_5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.40035 6.48002c0.6656 0 1.04 -0.3744 1.04 -1.04s-0.3744 -1.04 -1.04 -1.04 -1.04 0.3744 -1.04 1.04 0.3744 1.04 1.04 1.04Z"
                    strokeWidth={1}
                />
            </g>
        </svg>
    </div>
);

export default PaintPaletteIcon;
